export const PRINT_LOG_SORT = 'PRINT_LOG_SORT';

export function printLogSort(sortModel) {
  return {
    type: PRINT_LOG_SORT,
    payload: {
      sortModel,
    },
  };
}

